
import React from "react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import StepCard from "../StepCard";

interface ModeSelectorProps {
  onSelectFastMode: () => void;
  onSelectTutorialMode: () => void;
}

const ModeSelector = ({ onSelectFastMode, onSelectTutorialMode }: ModeSelectorProps) => {
  const navigate = useNavigate();

  const handlePrevious = () => {
    localStorage.removeItem("preferredSlicer");
    navigate('/tools');
  };

  return (
    <StepCard 
      title=""
      onPrevious={handlePrevious}
      showPrevious
    >
      <div className="space-y-4">
        <div className="text-center mb-6">
          <h3 className="text-lg font-semibold text-foreground mb-2">Choose Your Mode</h3>
          <p className="text-muted-foreground text-sm">Select how you'd like to use the calculator</p>
        </div>
        
        <div className="space-y-3">
          <Button
            onClick={onSelectFastMode}
            variant="outline"
            className="w-full p-6 h-auto bg-surface hover:bg-accent/50 border-border/50 transition-all duration-200"
          >
            <div className="text-center">
              <div className="font-semibold text-lg mb-1">Fast Mode</div>
              <div className="text-sm text-muted-foreground">
                Quick calculator without guidance
              </div>
            </div>
          </Button>
          
          <Button
            onClick={onSelectTutorialMode}
            variant="outline"
            className="w-full p-6 h-auto bg-surface hover:bg-accent/50 border-border/50 transition-all duration-200"
          >
            <div className="text-center">
              <div className="font-semibold text-lg mb-1">Tutorial Mode</div>
              <div className="text-sm text-muted-foreground">
                Step-by-step guided walkthrough
              </div>
            </div>
          </Button>
        </div>
      </div>
    </StepCard>
  );
};

export default ModeSelector;
